export default {"src":"/_next/static/media/klay.a50be928.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};